import { useMutation as useApolloMutation } from '@apollo/react-hooks';

const useMutation = (...args) => (
  useApolloMutation(...args)
);

export default useMutation;
